import styled from 'styled-components'

export const ItemWrapper = styled.div`
    border-color: rgba(209,213,219,1);
    display: flex;
    gap: 0.75rem;
    justify-content: center;
    flex-direction: column;
    width: 15.625rem;
    
    @media(min-width: 1024px){
        width: 13rem;
    }
`

export const ImageWrapper = styled.div`{
    min-height: 214px;
    max-height: 214px;

    padding: 0.5rem;
    border: 1px solid rgba(212,212,214,1);
    border-radius: 0.25rem;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: flex;
    position: relative;
    box-sizing: border-box;
    width: 15.625rem;
    
    @media(min-width: 1024px){
        width: 13rem;
    }
}`

export const ItemDetailWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 8px 8px 8px;
    height: 100%;
`
export const ItemDetails = styled.div`
    gap: 0.5rem;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
`

export const ItemDetailsAddToCart = styled.div`
    gap: 0.5rem;
    display: flex;
    flex-grow: 0;
    flex-direction: column;
`

export const DateDetails = styled.div`
    gap: 0.5rem;
    display: flex;
    flex-direction: column;
`
export const ProductTitle = styled.span`
    line-height: 1.25rem;
    font-size: .75rem;
    -webkit-font-smoothing: antialiased;
    text-decoration-thickness: auto;
    color: rgba(62,62,71,1)
    text-transform: uppercase;
    font-weight: 600;
    -webkit-line-clamp: 1;

    @media(min-width: 768px){
       line-height: 1.5rem;
       font-size: .875rem;
    }
`
export const ProductDesc = styled.span`
    text-decoration-thickness: auto;
    color: rgba(62,62,71,1)
    font-weight: 400;
    font-size: .75rem;
    min-height: 3rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    -webkit-font-smoothing: antialiased;

    @media(min-width: 1024px){
        line-height: 1.5rem;
        font-size: .875rem;
        min-height: 3rem;
    }

`
export const RatingWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.25rem;
    align-items: start;
    color: rgba(40,40,50,1);

    @media(min-width: 768px){
        flex-direction: row;
    }

    @media(min-width: 1440px){
        flex-wrap: nowrap;
    }
`
export const CountWrapper = styled.div`
    gap: 0.5rem;
    align-items: center;
    display: flex;
`
export const Count = styled.span`
    line-height: 1.25rem;
    font-size: .75rem;
    text-decoration-thickness: auto;
    font-size: 0.75rem;
`

export const PartLabel = styled.span`
    color: #5e5e65;
    line-height: 1.25rem;
    font-size: .75rem;
    padding-top: 0.125rem;
    display: block;
`

export const ProductPriceWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin-top: auto;
`

export const EmptyProductPriceWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: auto;
`

export const RegularPrice = styled.span`
    color: #3E3E47;
    line-height: 1.75rem;
    font-weight: 600;
    font-size: 1.125rem;
`

export const ListingPrice = styled.span`
    text-decoration-line: line-through;
    line-height: 1.25rem;
    font-weight: 400;
    font-size: .75rem;
`
